import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Macau: Country = {
    identifier: "Macau",
    name: "Macau",
    countryCode: "MO",
    group: CountryGroup.ASIA,
    isUNMember: false,
    flag: "🇲🇴",
    svgPath: "m 793.37275,399.4184 0.006,-0.066 0.037,-0.073 0.092,-0.013 0.059,0.07 -0.008,0.003 -0.131,0.06 -0.041,0.012 z",
}
